/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const BetweenVersion: core.serialization.ObjectSchema<serializers.BetweenVersion.Raw, Truvity.BetweenVersion> =
    core.serialization.object({
        left: core.serialization.number(),
        right: core.serialization.number(),
    });

export declare namespace BetweenVersion {
    export interface Raw {
        left: number;
        right: number;
    }
}
